<template>
    <div name="card2" class="card">
        <span class="title">“세법상 장애인 증명서 발급 받기가 너무 어려워요"</span>
        <span class="description" style="margin-top: 20px;">세법상 장애인 증명서<br>비대면 발급 기능 개발</span>
        <img class="image" src="../../../../assets/improvement_2.png" />
        <div class="button" @click="go" style="margin-top: 62px;">
            자세히 보기
        </div>
    </div>
</template>

<script>
export default {
    name: 'card1',
    methods: {    
        go: function()
        {
            window.open("https://cafe.naver.com/t1d/66162", "_blank")
        }

    }

}
</script>

<style scoped>
    .card {
        width: 702px;
        height: 260px;
        display: flex;
        flex-direction: column;
        padding: 32px 79.282px 32px 32px;
        border-radius: 18px;
        border: 1px solid var(--Gray-00, #FFF);
        background: var(--Gray-20, #F3F5F8);
        box-sizing: border-box;
        position: relative;
    }
    .image {
        width: 159.718px;
        position: absolute;
        right: 0;
        top: 43px;
        right: 79.28px;
    }
    .title {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 120% */
    }
    .description{
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 116.667% */
    }
    .button {
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 112.5% */
        width: 90px;
        height: 34px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/pc_uncomfortable/improvements/Card2.vue